var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParagraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1218_5107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1094 11.1731H32.0003V12.7624H16.1094V11.1731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.21875 23.8858H32.0003V25.4748H0.21875V23.8858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.21875 30.242H32.0003V31.8313H0.21875V30.242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1094 4.81693H32.0003V6.4059H16.1094V4.81693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.21875 17.5296H32.0003V19.1186H0.21875V17.5296Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.92969 8.78952H10.2196V10.3788H2.92969V8.78952Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7193 14.5004L6.57472 3.90329L1.43011 14.5004L0 13.8052L6.57472 0.268219L13.1497 13.8052L11.7193 14.5004Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1218_5107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParagraph);
export default __webpack_public_path__ + "static/media/paragraph.84ed8f087e22faf20fc964a3dc8cd316.svg";
export { ForwardRef as ReactComponent };